module.exports = __webpack_public_path__ + "img/lc-header-messages.c162b503.svg";